export default "__VITE_ASSET__CVdU_PhF__"